import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { TextField, InputAdornment } from "@mui/material";
import "../../styles/components/ModulesScreen.scss";
import "../../styles/pages/Banners/BannerManager.scss";
import time from "../../images/time.svg";
import checkmarkgreen from "../../images/ChecjmarkGreen.svg";
import expiredStatus from "../../images/expired status.svg";

import Microsoft from "../../images/download.png";
import Tooltip from "@mui/material/Tooltip";
import NoThumbanaill from "../../images/noThumbnail.svg";
import CannotExistRule from "../../images/CannotExistRule.svg";
import MustExistRule from "../../images/MustExistRule.svg";
import checkMark from "../../images/checkBlueFilledd.svg";
const ModulesCardNew = (props) => {
  const [data, setData] = useState([]);

  const {
    cardData,
    active,
    selectDeselectModule,
    createdDate,
    displayRulesClass,
    getModuleDetailsForPreview,
  } = props;
  const [cannotExistrule, setCannotExistrule] = useState(false);
  const [mustExistRule, setMustExistRule] = useState(false);
  const [modulePreviewData, setModulePreviewData] = useState(undefined);
  const [modulePreviewOpen, setModulePreviewOpen] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const mustAndcantexistStyles =
    displayRulesClass === "mustExistWithCards" ||
    (displayRulesClass === "mustExistWithCards" && "mustAndcantExistModule");
  const expired = cardData.mlrStatus.toLowerCase() === "expired";

  return (
    <div
      className="moduleCardContainer"
      // style={{ cursor: "pointer" }}
      style={{
        cursor:
          displayRulesClass === "mustExistWithCards" ||
          displayRulesClass === "cannotExistWithCards"
            ? "default"
            : expired
              ? "not-allowed"
              : "pointer",
      }}
      onClick={!expired && selectDeselectModule}
    >
      {active && displayRulesClass !== "mustExistWithCards" && !expired && (
        <img
          src={checkMark}
          //style={{ marginTop: "2px", marginLeft: "6px" }}

          alt="CheckMark"
          className="img-fluid bluecheckmark "
        />
      )}
      {displayRulesClass === "cannotExistWithCards" && (
        <img
          src={CannotExistRule}
          alt="CheckMark"
          className="img-fluid bluecheckmark canotExist"
        />
      )}

      {displayRulesClass === "mustExistWithCards" && (
        <img
          src={MustExistRule}
          alt="CheckMark"
          className="img-fluid bluecheckmark mustExist"
        />
      )}

      {/* { displayRulesClass === "cannotExistWithCards" ?
       (
        <img
          src={CannotExistRule}
          alt="CheckMark"
          className="img-fluid bluecheckmark canotExist"
        />
      ):

      displayRulesClass === "mustExistWithCards" ?  (
        <img
          src={MustExistRule}
          alt="CheckMark"
          className="img-fluid bluecheckmark mustExist"
        />
      ):active ?  (
        <img
          src={checkMark}
          //style={{ marginTop: "2px", marginLeft: "6px" }}

          alt="CheckMark"
          className="img-fluid bluecheckmark "
        /> ): ""} */}
      {/* {active && ( 
        <img
          src={active ? checkMark : cannotExistrule ? CannotExistRule : mustExistRule ? MustExistRule :"" }
          alt="CheckMark"
          className="img-fluid bluecheckmark"
        />
    )} */}
      <div
        //className={active ? "module-cardNew module-cardNewActive" : "module-cardNew"}
        className={`${
          active || mustAndcantexistStyles
            ? "module-cardNew module-cardNewActive"
            : "module-cardNew"
        } ${displayRulesClass} ${
          displayRulesClass === "cannotExistWithCards"
            ? "cannotExistWithCards"
            : ""
        }`}
      >
        <div
          className={`${displayRulesClass === "cannotExistWithCards" ? "moduleImageDiv cntexst" : "moduleImageDiv"}
          ${cardData?.componentUrl === null ? "noThumbnailbg" : ""}`}
        >
          <div
            // src={props.recentlyViewedData.thumbNail || url}
            style={{
              height: cardData?.componentUrl === null ? "126px" : "100px", //"126px",

              // backgroundImage: `url(${cardData.componentUrl})`
              backgroundImage:
                cardData?.componentUrl !== null
                  ? `url(${cardData.componentUrl})`
                  : `url(${NoThumbanaill})`,
            }}
            alt="Module"
            className={
              cardData?.componentUrl !== null
                ? "moduleImages img-fluid"
                : "moduleImages img-fluid moduleImagesEmptyThumbnail"
            }
          />
        </div>
        <div
          className={
            active || mustAndcantexistStyles
              ? "content-block content-blockActive"
              : expired
                ? "content-block content-blockExpired"
                : displayRulesClass === "cannotExistWithCards"
                  ? "content-block content-blockCannotExist"
                  : "content-block"
          }
        >
          <div
            className={`showStatusBg ${
              cardData?.mlrStatus === "Available for Use"
                ? "showStatusBgApproved"
                : cardData?.mlrStatus === "Expired"
                  ? "showStatusBgExpired"
                  : ""
            }`}
          >
            <p className="basic-info">
              <Tooltip title={cardData?.mlrStatus}>
                <img
                  src={expired ? expiredStatus : checkmarkgreen}
                  alt="checkmark"
                  className="img-fluid"
                />
              </Tooltip>
              {/* <Tooltip title={"Available for Use"}>
              <img src={checkmarkgreen} alt="checkmark" className="img-fluid" />
            </Tooltip> */}
              <div
                className={
                  // mustAndcantexistStyles
                  //   ? "mustAndcantExistModule cm-num "
                  // :
                  "cm-num "
                }
              >
                {cardData.moduleDamName}
                {expired && (
                  <Tooltip
                    title={"Module is expired can't be used for authoring"}
                  >
                    <div className="expiredModule">Expired</div>
                  </Tooltip>
                )}
              </div>{" "}
            </p>
          </div>
          <div></div>
          <div>
            {/* <p className="basic-info">
            <span>Product : </span>{" "}
            <strong
              className={
                mustAndcantexistStyles
                  ? "truncate2 infosec mustAndcantExistModule"
                  : "truncate2 infosec"
              }
            >
              {cardData.productName}
            </strong>
          </p> */}
            <div className="d-flex productTex">
              <p
                className="basic-info"
                style={{ marginBottom: "6px", width: "50%" }}
              >
                <span
                  className={
                    displayRulesClass === "cannotExistWithCards"
                      ? "nameHeading moduleCantExisttext"
                      : "nameHeading"
                  }
                >
                  Product:
                </span>{" "}
                <strong
                  className={
                    displayRulesClass === "cannotExistWithCards"
                      ? "truncate moduleCantExisttext"
                      : "truncate "
                  }
                >
                  {cardData.productName}
                </strong>
              </p>
              <p className="basic-info" style={{ marginBottom: "6px" }}>
                <span
                  className={
                    displayRulesClass === "cannotExistWithCards"
                      ? "nameHeading moduleCantExisttext"
                      : "nameHeading"
                  }
                >
                  Country:
                </span>{" "}
                <strong
                  className={
                    displayRulesClass === "cannotExistWithCards"
                      ? "truncate moduleCantExisttext"
                      : "truncate "
                  }
                >
                  {cardData.countryName}
                </strong>
              </p>
            </div>
            <p className="basic-info" style={{ marginBottom: "6px" }}>
              <span
                className={
                  displayRulesClass === "cannotExistWithCards"
                    ? "nameHeading moduleCantExisttext"
                    : "nameHeading"
                }
              >
                Name:
              </span>{" "}
              <Tooltip
                title={cardData.moduleName?.length > 10 && cardData.moduleName}
              >
                <strong
                  // className="truncate2"
                  className={
                    displayRulesClass === "cannotExistWithCards"
                      ? "truncate2 moduleCantExisttext"
                      : "truncate2 "
                  }
                >
                  {cardData.moduleName}
                </strong>
              </Tooltip>
            </p>

            <div className="d-flex time1">
              <div className="time">
                <img className="timeIcon" src={time}></img>
                {createdDate(cardData.editedDateTime)}
              </div>
              <button
                className="btn viewbtn "
                style={{ opacity: "1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  getModuleDetailsForPreview(cardData?.id);
                }}
              >
                View
              </button>
            </div>
            {/* <button className="btn view ">View</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModulesCardNew;
